import type { StreamEvent, StreamEventHandlerMap } from '../models';
import { dispatchStreamEvent } from '../models';
import { progressUpdated, toolStarted } from './agentChatSlice';
import type { TokenBuffer } from './tokenBuffer';

type Dispatch = (action: { type: string; payload?: unknown }) => void;

export function createStreamHandlers(dispatch: Dispatch, tokenBuffer: TokenBuffer): StreamEventHandlerMap {
  return {
    token: (event) => {
      tokenBuffer.append(event.data.content);
    },
    progress: (event) => {
      dispatch(progressUpdated(event.data.message));
    },
    tool_start: (event) => {
      dispatch(toolStarted({ toolName: event.data.toolName, displayName: event.data.displayName }));
    },
    node_end: () => {
      tokenBuffer.drain();
    },
    run_end: () => {
      tokenBuffer.drain();
    },
  };
}

export function handleStreamEvent(dispatch: Dispatch, event: StreamEvent, tokenBuffer: TokenBuffer): void {
  const handlers = createStreamHandlers(dispatch, tokenBuffer);
  dispatchStreamEvent(handlers, event);
}
